var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.155,
    height: 21.615,
    viewBox: "0 0 17.155 21.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5017",
    "data-name": "Path 5017",
    d: "M19.868,3H18.381v.743a2.233,2.233,0,0,1-2.23,2.23H10.2a2.233,2.233,0,0,1-2.23-2.23V3H6.487A1.488,1.488,0,0,0,5,4.487V22.328a1.488,1.488,0,0,0,1.487,1.487H19.868a1.488,1.488,0,0,0,1.487-1.487V4.487A1.488,1.488,0,0,0,19.868,3ZM11.319,21.213a.372.372,0,0,1-.372.372H8.717a.372.372,0,0,1-.372-.372v-2.23a.372.372,0,0,1,.372-.372h2.23a.372.372,0,0,1,.372.372Zm0-5.2a.372.372,0,0,1-.372.372H8.717a.372.372,0,0,1-.372-.372v-2.23a.372.372,0,0,1,.372-.372h2.23a.372.372,0,0,1,.372.372Zm0-5.2a.372.372,0,0,1-.372.372H8.717a.372.372,0,0,1-.372-.372V8.575A.372.372,0,0,1,8.717,8.2h2.23a.372.372,0,0,1,.372.372Zm6.319,10.779h-4.46a.372.372,0,1,1,0-.743h4.46a.372.372,0,1,1,0,.743Zm0-2.23h-4.46a.372.372,0,1,1,0-.743h4.46a.372.372,0,1,1,0,.743Zm0-2.974h-4.46a.372.372,0,1,1,0-.743h4.46a.372.372,0,1,1,0,.743Zm0-2.23h-4.46a.372.372,0,1,1,0-.743h4.46a.372.372,0,1,1,0,.743Zm0-2.974h-4.46a.372.372,0,1,1,0-.743h4.46a.372.372,0,1,1,0,.743Zm0-2.23h-4.46a.372.372,0,1,1,0-.743h4.46a.372.372,0,1,1,0,.743Z",
    transform: "translate(-4.6 -2.6)",
    fill: "#ffca3a",
    stroke: "#111",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.33dc5c0c990c95ea61a03d6e7e92570b.svg";
export { ForwardRef as ReactComponent };